import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UuidService } from 'src/app/services';

@Component({
  selector: 'app-add-authorized-signatory',
  templateUrl: './add-authorized-signatory.component.html',
  styleUrls: ['./add-authorized-signatory.component.scss']
})
export class AddAuthorizedSignatoryComponent {

  constructor(private uuidService: UuidService) { }
  fg: FormGroup = new FormGroup({
    id: new FormControl(this.uuidService.generateFormattedUUID()),
    authorizedSignatory: new FormControl(undefined, Validators.required),
    companyName: new FormControl(undefined, Validators.required),
    percentageOwnership: new FormControl(undefined, [Validators.required, Validators.min(0), Validators.max(100)])
  });
}
